import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/sebrene.jpg";
import full02 from "../assets/images/fulls/sebrene_lyrics.jpg";


import thumb01 from "../assets/images/fulls/sebrene.jpg";
import thumb02 from "../assets/images/fulls/sebrene_lyrics.jpg";




const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Sebrene Website</title>
        </Helmet>
        <div id="main">
    <h1>Sebrene Website</h1>
    <p>I created a website to market my self-published EP, “Melancholia”. I wanted something quick and simple that showcases the songs, lyrics, credits, and buy/stream links that matched the album art and marketing material.  I built the site with React.js and Gatsby.js to keep the site as simple and as fast as possible. </p>
    <a href="http://sebrene.com" class="button marginb">
      Live Website
    </a>
    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
